module.exports = "/_next/static/images/ship-bg-516b7f117b2080ac357196a48d912b55.png.webp";